<template>
  <v-dialog
    v-model="show"
    max-width="40vw"
    @click:outside="cancel"
  >
    <v-card
      flat
      class="pa-3 mt-2"
    >
      <v-card-title class="justify-center text-h5">
        {{ label }}
      </v-card-title>
      <v-card-text>
        <v-form class="multi-col-validation mt-6" ref="form">
          <v-row>
            <v-col
              md="6"
              cols="12"
            >
              <v-select
                v-model="type"
                :items="counterPartyTypeDropDown"
                :menu-props="{ maxHeight: '400' }"
                :error="hasErrorsForProperty(errors.errors, 'type')"
                :error-messages="errorMessages(errors.errors, 'type')"
                label="Наименование контрагента"
                dense
                :rules="[rules.required]"
                outlined
                persistent-hint
                hide-details
              ></v-select>
            </v-col>

            <v-col
              cols="12"
              md="6"
            >
              <v-select
                v-model="rk7TableCode"
                :items="tableDropDown"
                :menu-props="{ maxHeight: '400' }"
                label="Код стола"
                dense
                :rules="[rules.required]"
                outlined
                persistent-hint
                hide-details
              ></v-select>
            </v-col>

            <v-col
              cols="12"
              md="6"
            >
              <v-select
                v-model="rk7StationCode"
                :items="cashDropDown"
                :menu-props="{ maxHeight: '400' }"
                label="Код станции"
                dense
                :rules="[rules.required]"
                outlined
                persistent-hint
                hide-details
              ></v-select>
            </v-col>

            <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                v-model="externalSystemCode"
                label="ID заказа"
                dense
                outlined
                :rules="[rules.required, rules.integerValidator]"
              ></v-text-field>
            </v-col>


            <v-col
              md="12"
              cols="24"
            >
              <v-text-field
                v-model="comment"
                label="Комментарий"
                dense
                outlined
                :rules="[rules.required]"
              ></v-text-field>
            </v-col>

            <v-col cols="12">
              <v-btn
                @click="saveData"
                color="primary"
                class="me-3 mt-4"
              >
                Сохранить
              </v-btn>
              <v-btn
                color="secondary"
                outlined
                class="mt-4"
                type="reset"
                @click="cancel"
              >
                Отмена
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mdiCheck, mdiClose } from '@mdi/js'
import { mapFormHandlers } from '@/helpers/forms'
import { mapActions, mapGetters } from 'vuex'
import { rules } from '@/helpers/validation'
import { hasErrorsForProperty, errorMessages } from '@/helpers'

export default {
  name: 'CounterPartyForm',
  props: ['save', 'show', 'cancellation', 'label'],
  data: () => ({
    icons: {
      mdiCheck,
      mdiClose,
    },
    hasErrorsForProperty,
    errorMessages,
    rules,
  }),
  computed: {
    ...mapFormHandlers('counterParty/form', [
      'type',
      'rk7TableCode',
      'rk7StationCode',
      'externalSystemCode',
      'comment',
    ]),
    ...mapGetters('dictionary', { tableDropDown: 'tableDropDown' }),
    ...mapGetters('dictionary', { cashDropDown: 'cashDropDown' }),
    ...mapGetters('dictionary', { counterPartyTypeDropDown: 'counterPartyTypeDropDown' }),
  },
  async mounted() {
    await this.fetchTables()
    await this.fetchCashes()
    await this.fetchCounterPartyTypes()
  },
  watch: {
    show: function(newValue) {
      if (newValue && this.$refs.form) {
        this.$refs.form.resetValidation()
      }
    },
  },
  methods: {
    cancel() {
      this.resetForm()
      this.cancellation()
    },
    ...mapActions('counterParty/form', ['resetForm']),
    ...mapActions('dictionary', {
      fetchTables: 'fetchTables',
      fetchCashes: 'fetchCashes',
      fetchCounterPartyTypes: 'fetchCounterPartyTypes',
    }),
    async saveData() {
      if (this.$refs.form.validate()) {
        await this.save()
      }
    },
  },
}
</script>
